module.exports = __webpack_public_path__ + "img/drag.3d0d2213.svg";